
import { defineComponent, inject, ref } from '@vue/composition-api';
import VueRouter from 'vue-router';
import { LOAD_DATASET } from '../store/actions.type';
import { INTIALIZE_DATASET, SET_SELECTION } from '../store/mutations.type';
import analyses from './vis/analyses';
import store from '../store';

interface Dataset {
  id: string;
}

interface Problem {
  multi: boolean;
  type: string;
  context: string;
  row_index?: string;
  column_index?: string;
}

export default defineComponent({
  props: {
    problem: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      required: true,
      default: null,
    },
  },
  setup(props) {
    // TODO Use injected router instead of importing to avoid circular import
    const router = inject('router') as VueRouter;
    const datasets = ref(store.state.datasets);

    function valid(dataset: Dataset) {
      return store.getters.valid(dataset.id);
    }
    function isMerged(dataset: Dataset) {
      return store.getters.isMerged(dataset.id);
    }
    function problemNav(problem: Problem, id: string) {
      if (problem.multi) {
        router.push({ name: 'Problem', params: { id, problem: problem.type } }).catch(() => { });
      } else {
        router.push({ name: 'Clean Up Table', params: { id } }).catch(() => { });
        store.commit(SET_SELECTION, {
          key: id,
          event: {},
          axis: problem.context,
          // eslint-disable-next-line no-nested-ternary
          idx: (problem.context === 'row') ? problem.row_index
            : (problem.context === 'column') ? problem.column_index
              : undefined,
        });
      }
    }

    const dataset = store.getters.dataset(props.id);
    if (!dataset.value) {
      // initialize the dataset to prevent NPE race conditions during slow loads
      store.commit(INTIALIZE_DATASET, { dataset_id: props.id });
      store.dispatch(LOAD_DATASET, { dataset_id: props.id });
    }
    return {
      datasets,
      analyses,
      valid,
      isMerged,
      problemNav,
    };
  },
});
